import { useState } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import LessonListView from "features/teacher/components/lesson/LessonListView";
import StudentListView from "features/teacher/components/counsel/StudentListView";
import { hw, scrollbar } from "features/homework/homeworkUi";

const Counsel = () => {
    const [clickedLesson, setClickedLesson] = useState("");
    return (
        <Page>
            <PageHeader>
                <Title>상담등록</Title>
                <Desc>학급과 원생을 고른 뒤 상담 내용을 작성합니다.</Desc>
            </PageHeader>
            <Body>
                <Outlet />
                <LessonListView clickedItem={clickedLesson} setClickedItem={setClickedLesson} />
                {clickedLesson ? (
                    <StudentListView clickedLesson={clickedLesson} />
                ) : (
                    <EmptyPanel>
                        <EmptyTitle>학급을 선택하세요</EmptyTitle>
                        <EmptyText>왼쪽 목록에서 학급을 고르면 원생이 표시됩니다.</EmptyText>
                    </EmptyPanel>
                )}
            </Body>
        </Page>
    );
};

const Page = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
`;

const PageHeader = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px 16px;
    flex-shrink: 0;
`;

const Title = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${hw.text};
`;

const Desc = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${hw.textMuted};
`;

const Body = styled.div`
    display: grid;
    grid-template-columns: minmax(280px, 0.9fr) minmax(0, 1.1fr);
    gap: 16px;
    flex: 1;
    min-height: 0;

    @media (max-width: 960px) {
        grid-template-columns: minmax(0, 1fr);
        overflow: auto;
        ${scrollbar}
    }
`;

const EmptyPanel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 240px;
    padding: 24px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
    text-align: center;
`;

const EmptyTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${hw.text};
`;

const EmptyText = styled.div`
    font-size: 13px;
    color: ${hw.textMuted};
    line-height: 1.5;
`;

export default Counsel;
